import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BrandMarkComponent, PORTAL_BRAND_INITIALS } from '../brand-mark/brand-mark.component';

/**
 * La marca nelle barre del portale: marchio e nome del prodotto nello stesso riquadro chiaro, cosi' un
 * logo pensato per lo sfondo bianco si vede anche sul colore della barra. Sul telefono il nome esce dalla
 * vista ma non dall'albero accessibile: resta il marchio, e chi legge con lo screen reader sente comunque
 * di che portale si tratta — salvo dove la barra ha spazio e lo chiede (`nameAlwaysVisible`).
 */
@Component({
  selector: 'dxp-header-brand',
  standalone: true,
  imports: [BrandMarkComponent],
  templateUrl: './header-brand.component.html',
  styleUrl: './header-brand.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBrandComponent {
  /** Il nome del prodotto, gia' nella lingua mostrata. */
  @Input({ required: true }) name = '';

  /**
   * Il marchio del tenant, o `null` per le iniziali del portale. Il riquadro e' chiaro in entrambi i
   * temi: il chiamante passa il marchio per lo sfondo chiaro, non quello del tema dipinto.
   */
  @Input() markUrl: string | null = null;

  /**
   * Il nome resta a vista anche sul telefono. Lo chiede la barra che accanto alla marca ha poco o niente
   * — le pagine pubbliche col solo tondo del tema, la schermata di servizio non disponibile —: li' lo
   * spazio c'e', e il marchio da solo non dice il nome del prodotto.
   */
  @Input() nameAlwaysVisible = false;

  protected readonly initials = PORTAL_BRAND_INITIALS;
}
